import React from 'react';
import './PlanCard.css';

/* Card à en-tête blanc et pastille numérotée, née dans le Plan stratégique
   (2026-08) et restée aux trois panneaux de Finance qui l'utilisaient quand ce
   module a été retiré (2026-09-16) : Achats & stock, Capex & amortissements,
   panneau acheteur. Elle ne passe pas par `CardShell` — son entête porte un
   numéro d'étape, pas les sept zones du standard de carte. */
export function PlanCard({ num, title, note, right, children, flush = true, onNumClick }) {
  return (
    <div className="pcard">
      <div className="pcard__head">
        {num != null && (onNumClick
          ? <button type="button" className="pcard__num pcard__num--btn" onClick={onNumClick} aria-label="Replier / déplier">{num}</button>
          : <span className="pcard__num">{num}</span>)}
        <h3 className="pcard__title">{title}</h3>
        {note && <span className="pcard__note">{note}</span>}
        {right && <span className="pcard__right" style={{ marginLeft: 'auto' }}>{right}</span>}
      </div>
      <div className={flush ? 'pcard__body--flush' : 'pcard__body'}>{children}</div>
    </div>
  );
}

export default PlanCard;
